export default __webpack_public_path__ + "static/media/Ficha Técnica - Abacaxi Organico.b78fa2f9.pdf";